// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 97313) return "static/chunks/" + chunkId + "-69643701bdfe92c8.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"cf9766d1d2cdda07","32472":"de198c899652968b","76645":"68deefc5ff528024","87743":"434e636ed6ac4b7a"}[chunkId] + ".js";
};